<template>
    <div>
        <div class="col-md-12">
            <form  @submit.prevent="searchData()" role="form">
                <div class="row">
                    <div class="col-2">

                        <input type="text"
                               class="form-control"
                               v-model="pagingInfo.search"
                               placeholder="Plate No.." />

                    </div>
                    <div class="col-2">
                        <select name="Type" v-model="pagingInfo.type" class="form-control">
                            <option value>Select Type</option>
                            <option v-for="option in types"
                                    v-bind:value="option.transportationType"
                                    v-bind:key="option.transportationType">
                                {{ option.transportationType }}
                            </option>
                        </select>
                    </div>
                    <div class="col-2">

                        <select id="region"
                                class="form-control"
                                v-model="pagingInfo.mydata">
                            <option value="0">All Data</option>
                            <option value="1">My Encodes</option>
                        </select>

                    </div>
                    <div class="col-2">

                        <button type="submit" class="btn btn-info ">
                            <strong>Search</strong>
                        </button>&nbsp;
                        <button type="button" v-on:click="clearControls()" class="btn btn-primary">Clear</button>

                    </div>
                </div>
                
            </form>
            <br />

            <div class="box">
                <div class="box-header"></div>
                <div class="box-body table-responsive no-padding">
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th>Type</th>
                                <th>Plate No.</th>
                                <th>Motor/Chassis No.</th>
                                <th>Make</th>
                                <th>Model</th>
                                <th>Model Year</th>
                                <th>Color</th>
                                <th>Country</th>
                                <th>Comments</th>
                                <th>Created By</th>
                                <th>
                                    <a @click="sort('DateCreated')">Date Created</a>
                                </th>
                                <th>Updated By</th>
                                <th>
                                    <a @click="sort('DateUpdated')">Date Updated</a>
                                </th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="doc in docs" v-bind:key="doc.id">
                                <td>{{ doc.type | capitalize }}</td>
                                <td>{{ doc.principalID }}</td>
                                <td>{{ doc.additionalID }}</td>
                                <td>{{ doc.make }}</td>
                                <td>{{ doc.model }}</td>
                                <td>{{ doc.modelYear }}</td>
                                <td>{{ doc.color }}</td>
                                <td>{{ doc.country }}</td>
                                <td>{{ doc.comments }}</td>
                                <td>{{ doc.createdBy }}</td>
                                <td>{{ doc.dateCreated | formatDate }}</td>
                                <td>{{ doc.updatedBy }}</td>
                                <td>{{ doc.dateUpdated | formatDate }}</td>
                                <td v-if="$store.getters.LINKMODE">
                                    <button class="btn btn-sm btn-success"
                                            @click="setLink(doc.id)">
                                        Link Object
                                    </button>
                                </td>
                                <td v-else-if="$store.getters.CRAD">
                                    <TheDropDownButton>
                                        <btn @click.native="editTrans(doc.id)"
                                             icon="fa fa-pencil-alt"
                                             title="Edit"></btn>
                                        <btn @click.native="requestlinkdownload(doc.id)"
                                             icon="fa fa-cloud-download-alt"
                                             title="Export"></btn>
                                        <btn @click.native="More(doc)"
                                             icon="fa fa-expand-alt"
                                             title="View Linkages"></btn>
                                        <btn @click.native="addtoMerge(doc)"
                                             icon="fa fa-code-branch"
                                             title="Merge Record"></btn>
                                    </TheDropDownButton>
                                </td>
                                <td v-else-if="$store.getters.VIEWER">
                                    <TheDropDownButton>
                                        <btn @click.native="More(doc)" icon="fa fa-expand-alt" title="View Linkages"></btn>
                                    </TheDropDownButton>
                                </td>
                                <td v-else>
                                    <TheDropDownButton>
                                        <btn v-if="mydata"
                                             @click.native="editTrans(doc.id)"
                                             icon="fa fa-pencil-alt"
                                             title="Edit"></btn>
                                        <btn @click.native="More(doc)"
                                             icon="fa fa-expand-alt"
                                             title="View Linkages"></btn>
                                    </TheDropDownButton>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div v-show="totalitems == 0" class="alert alert-warning">
                        <p>Found no result try again</p>
                    </div>
                </div>
            </div>

            <b-pagination v-model="pagingInfo.page"
                          v-on:input="fetchData()"
                          :total-rows="totalitems"
                          :per-page="pagingInfo.itemsPerPage"
                          first-text="First"
                          prev-text="Prev"
                          next-text="Next"
                          last-text="Last"></b-pagination>
        </div>
        <div>
            <b-modal id="LinkPopupTR" title="Link Builder" scrollable hide-footer>
                <LinkPopUp />
            </b-modal>
            <b-modal id="EditPopUPTR"
                     title="Edit Transportation"
                     size="lg"
                     scrollable
                     hide-footer>
                <EditTransportation v-bind:id="TransID"
                                    v-on:done-edit-trans="doneEdit()" />
            </b-modal>
            <b-modal id="linkpopuptr" size="xl" scrollable hide-footer>
                <LinkComponentPopTr v-bind:id="linkid"
                                    v-bind:linkdescription="linkdescription" />
            </b-modal>
            <b-modal id="mergerecordtr"
                     size="md"
                     hide-footer
                     ref="merger"
                     no-close-on-esc="true"
                     no-close-on-backdrop="true"
                     hide-header-close="true">
                <MergePopUptr v-bind:obj1ID="obj1Id"
                            v-bind:obj2ID="obj2Id"
                            v-bind:obj1Desc="obj1description"
                            v-bind:obj2Desc="obj2description"
                            v-bind:objType="objType"
                            v-on:done="done()"
                            v-on:cancel="cancel()" />
            </b-modal>
        </div>
    </div>
</template>

<script>
    import {
        authHeader,
        responseCheck,
        RecordURL,
        setObject2Link,
        RequestLink,
        notifyHelper,
        getlocalstorageTransportationType
    } from "../helper";
    import LinkPopUp from "./master/Linking";
    import EditTransportation from "./edit/Transportation";
    import btn from "./buttons/iconButton";
    import LinkComponentPopTr from "./link/linkcomponent";
    import MergePopUptr from "./master/recordMerge";
    import instance from '../helper/http'
    export default {
        data() {
            return {
                docs: [],
                pagingInfo: {
                    page: 1,
                    search: "",
                    sortBy: "",
                    reverse: false,
                    mydata: 0,
                    type: ""
                },
                totalitems: null,
                TransID: "",
                mydata: false,
                linkid: "",
                linkdescription: "",
                obj1Id: "",
                obj2Id: "",
                objType: "",
                obj1description: "",
                obj2description: "",
                hasfirst: false,
                types: []
            };
        },
        components: {
            LinkPopUp,
            EditTransportation,
            btn,
            LinkComponentPopTr,
            MergePopUptr
        },
        created: function () {
            this.getlibs();
        },
        methods: {
            async requestlinkdownload(id) {
                await RequestLink(id);
            },
            clearControls() {
                this.pagingInfo.search = "";
            },
            getlibs() {
                
                this.types = getlocalstorageTransportationType();
            },
            fetchData() {
                if (this.pagingInfo.mydata == "0") this.mydata = false;
                else this.mydata = true;

                instance
                    .get(RecordURL + "getrtransportation", {
                        headers: authHeader(),
                        params: this.pagingInfo,
                    })
                    .then((response) => {
                        this.docs = response.data.data;
                        this.totalitems = response.data.count;
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status)
                        this.mydata = false;
                        this.docs = [];
                        this.totalitems = 0;
                    })
            },
            addtoMerge(data) {
                var additional =
                    (data.type ? data.type : "") +
                    " " +
                    (data.make ? data.make : "") +
                    " " +
                    (data.model ? data.model : "") +
                    " " +
                    (data.principalId ? data.principalId : "");
                additional = additional.replace(/\//g, "-");
                if (this.hasfirst) {
                    if (this.obj1Id == data.id) {
                        notifyHelper("info", "Cannot merge the same transportation");
                    }
                    else {
                        this.obj2description = additional;
                        this.obj2Id = data.id;
                        this.objType = "TR"
                        //open the popup
                        this.$bvModal.show("mergerecordtr");
                    }

                } else {
                    this.obj1description = additional;
                    this.obj1Id = data.id;
                    this.hasfirst = true;
                    notifyHelper(
                        "success",
                        "Add to merging of record, please choose another record to merge"
                    );
                }
            },
            cancel() {
                this.$bvModal.hide("mergerecordtr");
                this.hasfirst = false;
                this.obj1Id = "";
                this.obj2Id = "";
                this.obj1description = "";
                this.obj2description = "";
            },
            done() {
                this.$bvModal.hide("mergerecordtr");
                this.hasfirst = false;
                this.obj1Id = "";
                this.obj2Id = "";
                this.obj1description = "";
                this.obj2description = "";
                this.fetchData();
            },
            searchData() {
                this.pagingInfo.page = 1;
                this.fetchData();
            },
            More: function (data) {
                var additional1 = (data.type ? data.type : '') + " " + (data.make ? data.make : '') + " " + (data.principalId ? data.principalId : '')
                additional1 = additional1.replace(/\//g, "-");
                // this.$router.replace({
                //   name: "Links",
                //   params: { id: data.id, description: additional1 },
                // });
                this.linkid = data.id;
                this.linkdescription = additional1;
                this.$bvModal.show("linkpopuptr");
            },
            sort: function (sortBy) {
                if (sortBy === this.pagingInfo.sortBy) {
                    this.pagingInfo.reverse = !this.pagingInfo.reverse;
                } else {
                    this.pagingInfo.sortBy = sortBy;
                    this.pagingInfo.reverse = false;
                }
                this.pagingInfo.page = 1;
                this.fetchData();
            },
            setLink: function (id) {
                setObject2Link(id, "TR");
                this.$bvModal.show("LinkPopupTR");
            },
            editTrans: function (id) {
                this.TransID = id;
                //modal
                this.$bvModal.show("EditPopUPTR");
            },
            doneEdit() {
                this.$bvModal.hide("EditPopUPTR");
            },
        },
    };
</script>

